import { render } from "./EditAccountData.vue?vue&type=template&id=af59cad8"
import script from "./EditAccountData.vue?vue&type=script&lang=js"
export * from "./EditAccountData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__